import { getToken, returnError } from './helperFunc';
import {
	einvoiceListAction,
	fetchInvoiceCyclesAction,
	submitSelectedCycleAction,
	fetchConsolidateListAction,
	fetchAllDataConsolidateAction,
	submitSelectedOutletAction,
	einvoiceListEpaymentAction,
	fetchInvoiceEpaymentAction,
	submitSelectedEpaymentAction,
	einvoiceReportAction,
	cancelSelectedCycleAction,
	cancelSelectedEpaymentAction,
	cancelConsolidateAction,
	einvoiceListPackageAction,
	cancelSelectedPackageAction,
	rejectSelectedCycleAction,
	rejectSelectedEpaymentAction,
} from './requestEndpoints';

const SET_LOADING_INVOICE = 'SET_LOADING_INVOICE';
const CLEAR_ERROR_INVOICE = 'CLEAR_ERROR_INVOICE';

const GET_INVOICE_LIST_SUCCESS = 'GET_INVOICE_LIST_SUCCESS';
const GET_INVOICE_LIST_FAIL = 'GET_INVOICE_LIST_FAIL';

const GET_CYCLE_LIST_SUCCESS = 'GET_CYCLE_LIST_SUCCESS';
const GET_CYCLE_LIST_FAIL = 'GET_CYCLE_LIST_FAIL';

const UPDATE_CYCLE_SUCCESS = 'UPDATE_CYCLE_SUCCESS';
const UPDATE_CYCLE_FAIL = 'UPDATE_CYCLE_FAIL';

const SET_LOADING_CONSOLIDATE = 'SET_LOADING_CONSOLIDATE';
const CLEAR_ERROR_CONSOLIDATE = 'CLEAR_ERROR_CONSOLIDATE';

const GET_CONSOLIDATE_SUCCESS = 'GET_CONSOLIDATE_SUCCESS';
const GET_CONSOLIDATE_FAIL = 'GET_CONSOLIDATE_FAIL';

const GET_CONSOLIDATE_DATA_SUCCESS = 'GET_CONSOLIDATE_DATA_SUCCESS';
const GET_CONSOLIDATE_DATA_FAIL = 'GET_CONSOLIDATE_DATA_FAIL';

const UPDATE_DATA_SUCCESS = 'UPDATE_DATA_SUCCESS';
const UPDATE_DATA_FAIL = 'UPDATE_DATA_FAIL';

const GET_INVOICE_EPAYMENT_LIST_SUCCESS = 'GET_INVOICE_EPAYMENT_LIST_SUCCESS';
const GET_INVOICE_EPAYMENT_LIST_FAIL = 'GET_INVOICE_EPAYMENT_LIST_FAIL';

const GET_EPAYMENT_LIST_SUCCESS = 'GET_EPAYMENT_LIST_SUCCESS';
const GET_EPAYMENT_LIST_FAIL = 'GET_EPAYMENT_LIST_FAIL';

const UPDATE_EPAYMENT_SUCCESS = 'UPDATE_EPAYMENT_SUCCESS';
const UPDATE_EPAYMENT_FAIL = 'UPDATE_EPAYMENT_FAIL';

const EINVOICE_RECORD_SUCCESS = 'EINVOICE_RECORD_SUCCESS';
const EINVOICE_RECORD_FAIL = 'EINVOICE_RECORD_FAIL';

const CANCEL_CYCLE_SUCCESS = 'CANCEL_CYCLE_SUCCESS';
const CANCEL_CYCLE_FAIL = 'CANCEL_CYCLE_FAIL';

const CANCEL_EPAYMENT_SUCCESS = 'CANCEL_EPAYMENT_SUCCESS';
const CANCEL_EPAYMENT_FAIL = 'CANCEL_EPAYMENT_FAIL';

const CANCEL_CONSOLIDATE_SUCCESS = 'CANCEL_CONSOLIDATE_SUCCESS';
const CANCEL_CONSOLIDATE_FAIL = 'CANCEL_CONSOLIDATE_FAIL';

const GET_INVOICE_LIST_PACKAGE_SUCCESS = 'GET_INVOICE_LIST_PACKAGE_SUCCESS';
const GET_INVOICE_LIST_PACKAGE_FAIL = 'GET_INVOICE_LIST_PACKAGE_FAIL';

const CANCEL_PACKAGE_SUCCESS = 'CANCEL_PACKAGE_SUCCESS';
const CANCEL_PACKAGE_FAIL = 'CANCEL_PACKAGE_FAIL';

const REJECT_CYCLE_SUCCESS = 'REJECT_CYCLE_SUCCESS';
const REJECT_CYCLE_FAIL = 'REJECT_CYCLE_FAIL';

const REJECT_EPAYMENT_SUCCESS = 'REJECT_EPAYMENT_SUCCESS';
const REJECT_EPAYMENT_FAIL = 'REJECT_EPAYMENT_FAIL';

export const einvoiceList = (operatorId, statusFilter) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_INVOICE });
		dispatch({ type: SET_LOADING_INVOICE });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await einvoiceListAction(operatorId, statusFilter, token);

		dispatch({ type: GET_INVOICE_LIST_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: GET_INVOICE_LIST_FAIL, payload: returnError(error) });
	}
};

export const fetchInvoiceCycles = (dataBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_INVOICE });
		dispatch({ type: SET_LOADING_INVOICE });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await fetchInvoiceCyclesAction(dataBody, token);

		dispatch({ type: GET_CYCLE_LIST_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: GET_CYCLE_LIST_FAIL, payload: returnError(error) });
	}
};

export const submitSelectedCycle = (dataBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_INVOICE });
		dispatch({ type: SET_LOADING_INVOICE });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await submitSelectedCycleAction(dataBody, token);

		dispatch({ type: UPDATE_CYCLE_SUCCESS, payload: data });
		return true;
	} catch (error) {
		dispatch({ type: UPDATE_CYCLE_FAIL, payload: returnError(error) });
		return false;
	}
};

export const consolidateList = (dataBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_CONSOLIDATE });
		dispatch({ type: SET_LOADING_CONSOLIDATE });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await fetchConsolidateListAction(dataBody, token);

		dispatch({ type: GET_CONSOLIDATE_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: GET_CONSOLIDATE_FAIL, payload: returnError(error) });
	}
};

export const fetchConsolidateData = (dataBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_CONSOLIDATE });
		dispatch({ type: SET_LOADING_CONSOLIDATE });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await fetchAllDataConsolidateAction(dataBody, token);

		console.log(data);

		dispatch({ type: GET_CONSOLIDATE_DATA_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: GET_CONSOLIDATE_DATA_FAIL, payload: returnError(error) });
	}
};

export const submitSelectedOutlet = (dataBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_INVOICE });
		dispatch({ type: SET_LOADING_INVOICE });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await submitSelectedOutletAction(dataBody, token);

		dispatch({ type: UPDATE_DATA_SUCCESS, payload: data });
		return true;
	} catch (error) {
		dispatch({ type: UPDATE_DATA_FAIL, payload: returnError(error) });
		return false;
	}
};

export const einvoiceEpaymentList = (operatorId, statusFilter) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_INVOICE });
		dispatch({ type: SET_LOADING_INVOICE });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await einvoiceListEpaymentAction(operatorId, statusFilter, token);

		dispatch({ type: GET_INVOICE_EPAYMENT_LIST_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: GET_INVOICE_EPAYMENT_LIST_FAIL, payload: returnError(error) });
	}
};

export const fetchInvoiceEpaymentCycles = (dataBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_INVOICE });
		dispatch({ type: SET_LOADING_INVOICE });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await fetchInvoiceEpaymentAction(dataBody, token);

		dispatch({ type: GET_EPAYMENT_LIST_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: GET_EPAYMENT_LIST_FAIL, payload: returnError(error) });
	}
};

export const submitSelectedEpayment = (dataBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_INVOICE });
		dispatch({ type: SET_LOADING_INVOICE });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await submitSelectedEpaymentAction(dataBody, token);

		dispatch({ type: UPDATE_EPAYMENT_SUCCESS, payload: data });
		return true;
	} catch (error) {
		dispatch({ type: UPDATE_EPAYMENT_FAIL, payload: returnError(error) });
		return false;
	}
};

export const eInvoiceReport = (values) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_INVOICE });
		dispatch({ type: SET_LOADING_INVOICE });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await einvoiceReportAction(values, token);
		// console.log(data);
		dispatch({ type: EINVOICE_RECORD_SUCCESS, payload: data });
		// console.log(data);
	} catch (error) {
		dispatch({ type: EINVOICE_RECORD_FAIL, payload: returnError(error) });
	}
};

export const cancelSelectedCycle = (dataBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_INVOICE });
		dispatch({ type: SET_LOADING_INVOICE });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await cancelSelectedCycleAction(dataBody, token);

		dispatch({ type: CANCEL_CYCLE_SUCCESS, payload: data });
		return true;
	} catch (error) {
		dispatch({ type: CANCEL_CYCLE_FAIL, payload: returnError(error) });
		return false;
	}
};

export const cancelSelectedEpayment = (dataBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_INVOICE });
		dispatch({ type: SET_LOADING_INVOICE });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await cancelSelectedEpaymentAction(dataBody, token);

		dispatch({ type: CANCEL_EPAYMENT_SUCCESS, payload: data });
		return true;
	} catch (error) {
		dispatch({ type: CANCEL_EPAYMENT_FAIL, payload: returnError(error) });
		return false;
	}
};

export const cancelConsolidate = (dataBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_INVOICE });
		dispatch({ type: SET_LOADING_INVOICE });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await cancelConsolidateAction(dataBody, token);

		dispatch({ type: CANCEL_CONSOLIDATE_SUCCESS, payload: data });
		return true;
	} catch (error) {
		dispatch({ type: CANCEL_CONSOLIDATE_FAIL, payload: returnError(error) });
		return false;
	}
};

export const einvoicePackageList = (operatorId, statusFilter) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_INVOICE });
		dispatch({ type: SET_LOADING_INVOICE });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await einvoiceListPackageAction(operatorId, statusFilter, token);

		dispatch({ type: GET_INVOICE_LIST_PACKAGE_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: GET_INVOICE_LIST_PACKAGE_FAIL, payload: returnError(error) });
	}
};

export const cancelSelectedPackage = (dataBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_INVOICE });
		dispatch({ type: SET_LOADING_INVOICE });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await cancelSelectedPackageAction(dataBody, token);

		dispatch({ type: CANCEL_PACKAGE_SUCCESS, payload: data });
		return true;
	} catch (error) {
		dispatch({ type: CANCEL_PACKAGE_FAIL, payload: returnError(error) });
		return false;
	}
};

export const rejectSelectedCycle = (dataBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_INVOICE });
		dispatch({ type: SET_LOADING_INVOICE });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await rejectSelectedCycleAction(dataBody, token);

		dispatch({ type: REJECT_CYCLE_SUCCESS, payload: data });
		return true;
	} catch (error) {
		dispatch({ type: REJECT_CYCLE_FAIL, payload: returnError(error) });
		return false;
	}
};

export const rejectSelectedEpayment = (dataBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_INVOICE });
		dispatch({ type: SET_LOADING_INVOICE });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await rejectSelectedEpaymentAction(dataBody, token);

		dispatch({ type: REJECT_EPAYMENT_SUCCESS, payload: data });
		return true;
	} catch (error) {
		dispatch({ type: REJECT_EPAYMENT_FAIL, payload: returnError(error) });
		return false;
	}
};

const initialState2 = {
	language: 'en',
	loading: false,
	error: null,
	einvoiceLists: [],
	cycleLists: [],
	consolidateLists: [],
	consolidateDataLists: [],
	einvoiceEpaymentLists: [],
	epaymentLists: [],
	einvoicePackageLists: []
};

export const einvoiceReducer = function (state = initialState2, action) {
	switch (action.type) {
		// this is for fetching loading time setter
		case SET_LOADING_INVOICE:
			return {
				...state,
				loading: true,
			};

		case CLEAR_ERROR_INVOICE:
			return {
				...state,
				error: null,
				loading: false,
			};

		case GET_INVOICE_LIST_SUCCESS:
			return {
				...state,
				einvoiceLists: action.payload.data,
				loading: false,
				error: null,
			};

		case GET_CYCLE_LIST_SUCCESS:
			return {
				...state,
				cycleLists: action.payload.data,
				loading: false,
				error: null,
		}

		case SET_LOADING_CONSOLIDATE:
			return {
				...state,
				loading: true,
		};

		case CLEAR_ERROR_CONSOLIDATE:
			return {
				...state,
				error: null,
				loading: false,
			};

		case GET_CONSOLIDATE_SUCCESS:
			return {
				...state,
				consolidateLists: action.payload.data,
				loading: false,
				error: null,
			};

		case GET_CONSOLIDATE_DATA_SUCCESS:
			return {
				...state,
				consolidateDataLists: action.payload.data,
				loading: false,
				error: null,
		}

		case GET_INVOICE_EPAYMENT_LIST_SUCCESS:
			return {
				...state,
				einvoiceEpaymentLists: action.payload.data,
				loading: false,
				error: null,
			};

		case GET_EPAYMENT_LIST_SUCCESS:
			return {
				...state,
				epaymentLists: action.payload.data,
				loading: false,
				error: null,
		}

		case EINVOICE_RECORD_SUCCESS:
			return {
				einvoice: action.payload.data,
				loading: false,
				error: null,
				company: action.payload.company,
				consolidationData: action.payload.consolidationData
		};

		case GET_INVOICE_LIST_PACKAGE_SUCCESS:
			return {
				...state,
				einvoicePackageLists: action.payload.data,
				loading: false,
				error: null,
			};

		case UPDATE_DATA_FAIL:
		case GET_CONSOLIDATE_DATA_FAIL:
		case GET_CONSOLIDATE_FAIL:
		case GET_INVOICE_LIST_FAIL:
		case GET_CYCLE_LIST_FAIL:
		case UPDATE_CYCLE_FAIL: 
		case GET_INVOICE_EPAYMENT_LIST_FAIL:
		case GET_EPAYMENT_LIST_FAIL:
		case UPDATE_EPAYMENT_FAIL: 
		case EINVOICE_RECORD_FAIL:
		case CANCEL_CONSOLIDATE_FAIL:
		case CANCEL_EPAYMENT_FAIL:
		case CANCEL_PACKAGE_FAIL:
		case CANCEL_CYCLE_FAIL:
		case REJECT_CYCLE_FAIL:
		case REJECT_EPAYMENT_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};

		default:
			return state;
	}
};
